<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Form User ' + title" @back="back">
            
        </a-page-header>

        <a-card type="inner" size="small">
            <a-skeleton :loading="preload" active>
                <a-form :form="form" @submit="handleSubmit">
                    <a-row>
                        <a-col :span="12">

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Kelas"
                            >
                                <a-select
                                    v-decorator="['class_id']"
                                    placeholder="Pilih Kelas"
                                >
                                    <a-select-option
                                        v-for="d in classes"
                                        :key="d.id"
                                        :value="d.id"
                                    >
                                        {{ d.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Nama"
                            >
                                <a-input
                                    placeholder="Nama"
                                    v-decorator="[
                                        'name',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Field ini wajib diisi'
                                                }
                                            ]
                                        }
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="user"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Email"
                            >
                                <a-input
                                    placeholder="Email"
                                    type="email"
                                    v-decorator="[
                                        'email',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Field ini wajib diisi'
                                                },
                                                {
                                                    type: 'email',
                                                    message: 'Alamat email harus valid',
                                                    trigger: 'change'
                                                }
                                            ]
                                        }
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="mail"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Tanggal lahir"
                            >
                                <a-date-picker
                                    :format="'YYYY-MM-DD'"
                                    v-decorator="[
                                        'birthday',
                                        {
                                            type: 'object'
                                        }
                                    ]"
                                />
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Tempat Lahir"
                            >
                                <a-input
                                    placeholder="Tempat lahir"
                                    v-decorator="[
                                        'birthplace'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="home"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-model-item
                                label="Gender"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                            >
                                <a-radio-group
                                    v-decorator="[
                                        'gender',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Pilih jenis kelamin'
                                                }
                                            ]
                                        }
                                    ]">
                                    <a-radio style="display: block;lineHeight: 30px;height: 30px" value="male">
                                    Laki-laki
                                    </a-radio>
                                    <a-radio style="display: block;lineHeight: 30px;height: 30px" value="female">
                                    Perempuan
                                    </a-radio>
                                </a-radio-group>
                            </a-form-model-item>

                            <!-- <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Divisi"
                            >
                                <a-input
                                    placeholder="Divisi"
                                    v-decorator="[
                                        'division'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="user"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item> -->

                            <!-- <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Jabatan"
                            >
                                <a-input
                                    placeholder="Jabatan"
                                    v-decorator="[
                                        'position'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="user"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item> -->

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Alamat Kantor"
                            >
                                <a-input
                                    placeholder="Alamat kantor"
                                    v-decorator="[
                                        'office_address'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="bank"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Telepon Kantor"
                            >
                                <a-input
                                    placeholder="Telepon kantor"
                                    v-decorator="[
                                        'office_phone'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="phone"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Alamat Rumah"
                            >
                                <a-input
                                    placeholder="Alamat rumah"
                                    v-decorator="[
                                        'home_address'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="home"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Telpon Rumah"
                            >
                                <a-input
                                    placeholder="Telpon rumah"
                                    v-decorator="[
                                        'home_phone'
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="phone"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-model-item
                                label="Status"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                            >
                                <a-switch 
                                    label="Status"
                                    :label-col="{ span: layout.label }"
                                    :wrapper-col="{ span: layout.wrapper }"
                                    checked-children="Aktif"
                                    un-checked-children="Nonaktif"
                                    v-decorator="[
                                        'is_active',
                                        {
                                            valuePropName: 'checked',
                                            initialValue: true
                                        }
                                    ]" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="No Handphone"
                            >
                                <a-input
                                    placeholder="Nomor Handphone"
                                    v-decorator="['mobile_phone', 
                                    {
                                        rules: [
                                                {
                                                    required: true,
                                                    message: 'Field ini wajib diisi'
                                                }
                                            ]
                                        }
                                    ]"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="mobile"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Pendidikan"
                            >
                                <a-input
                                    placeholder="Pendidikan"
                                    v-decorator="['education']"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="star"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Jurusan"
                            >
                                <a-input
                                    placeholder="Jurusan"
                                    v-decorator="['majors']"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="tag"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Universitas"
                            >
                                <a-input
                                    placeholder="Universitas"
                                    v-decorator="['university']"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="apartment"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Facebook"
                            >
                                <a-input
                                    placeholder="Facebook"
                                    v-decorator="['facebook']"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="facebook"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Twitter"
                            >
                                <a-input
                                    placeholder="Twitter"
                                    v-decorator="['twitter']"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="twitter"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Linkedin"
                            >
                                <a-input
                                    placeholder="Linkedin"
                                    v-decorator="['linkedin']"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="linkedin"
                                        style="color: rgba(0, 0, 0, 0.25)"
                                    />
                                </a-input>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Pengalaman kerja"
                            >
                                <a-textarea placeholder="Answer" :rows="4" v-decorator="['work_experience']" />
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Hobi"
                            >
                                <a-textarea placeholder="Answer" :rows="4" v-decorator="['hobby']" />
                            </a-form-item>

                            <a-form-model-item
                                v-if="!teamProject"
                                label="Status Perkawinan"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                            >
                                <a-radio-group v-decorator="['family_status']">
                                    <a-radio style="display: block;lineHeight: 30px;height: 30px" value="single">
                                    Belum Kawin
                                    </a-radio>
                                    <a-radio style="display: block;lineHeight: 30px;height: 30px" value="married">
                                    Kawin
                                    </a-radio>
                                    <a-radio style="display: block;lineHeight: 30px;height: 30px" value="divorced">
                                    Cerai
                                    </a-radio>
                                </a-radio-group>
                            </a-form-model-item>

                            <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Role Klasikal"
                            >
                                <a-select
                                    v-decorator="['classical_role']"
                                >
                                    <a-select-option
                                        key="project-owner"
                                        value="project-owner"
                                    >
                                        Project Owner
                                    </a-select-option>
                                    <a-select-option
                                        key="project-manager"
                                        value="project-manager"
                                    >
                                        Project Manager
                                    </a-select-option>
                                    <a-select-option
                                        key="project-owner-client"
                                        value="project-owner-client"
                                    >
                                        Project Owner Client
                                    </a-select-option>
                                    <a-select-option
                                        key="project-manager-client"
                                        value="project-manager-client"
                                    >
                                        Project Manager Client
                                    </a-select-option>
                                    <a-select-option
                                        key="inspirator"
                                        value="inspirator"
                                    >
                                        Inspirator
                                    </a-select-option>
                                    <a-select-option
                                        key="project-sponsor"
                                        value="project-sponsor"
                                    >
                                        Project Sponsor
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Role OJT"
                            >
                                <a-select
                                    v-decorator="['ojt_role']"
                                    @change="handleChange"
                                >
                                    <a-select-option
                                        key="advisor"
                                        value="advisor"
                                    >
                                        Pembimbing
                                    </a-select-option>
                                    <a-select-option
                                        key="evaluator"
                                        value="evaluator"
                                    >
                                        Evaluator
                                    </a-select-option>
                                    <a-select-option
                                        key="mentor"
                                        value="mentor"
                                    >
                                        Mentor
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Cabang"
                            >
                                <a-select
                                    v-decorator="[
                                        'branch_id',
                                    ]"
                                >
                                    <a-select-option
                                        v-for="d in branches"
                                        :key="d.hash"
                                        :value="d.hash"
                                    >
                                        {{ d.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <!-- <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Role Makalah"
                            >
                                <a-select
                                    v-decorator="['paper_role']"
                                >
                                    <a-select-option
                                        key="advisor"
                                        value="advisor"
                                    >
                                        Pembimbing
                                    </a-select-option>
                                    <a-select-option
                                        key="evaluator"
                                        value="evaluator"
                                    >
                                        Evaluator
                                    </a-select-option>
                                    <a-select-option
                                        key="mentor"
                                        value="mentor"
                                    >
                                        Mentor
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Role Project Management"
                            >
                                <a-select
                                    v-decorator="['project_role']"
                                >
                                    <a-select-option
                                        key="advisor"
                                        value="advisor"
                                    >
                                        Pembimbing
                                    </a-select-option>
                                    <a-select-option
                                        key="evaluator"
                                        value="evaluator"
                                    >
                                        Evaluator
                                    </a-select-option>
                                    <a-select-option
                                        key="mentor"
                                        value="mentor"
                                    >
                                        Mentor
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Role Performance"
                            >
                                <a-select
                                    v-decorator="['performance_role']"
                                >
                                    <a-select-option
                                        key="advisor"
                                        value="advisor"
                                    >
                                        Pembimbing
                                    </a-select-option>
                                    <a-select-option
                                        key="evaluator"
                                        value="evaluator"
                                    >
                                        Evaluator
                                    </a-select-option>
                                    <a-select-option
                                        key="mentor"
                                        value="mentor"
                                    >
                                        Mentor
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-if="teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Role Evaluation"
                            >
                                <a-select
                                    v-decorator="['evaluation_role']"
                                >
                                   <a-select-option
                                        key="advisor"
                                        value="advisor"
                                    >
                                        Pembimbing
                                    </a-select-option>
                                    <a-select-option
                                        key="evaluator"
                                        value="evaluator"
                                    >
                                        Evaluator
                                    </a-select-option>
                                    <a-select-option
                                        key="mentor"
                                        value="mentor"
                                    >
                                        Mentor
                                    </a-select-option>
                                </a-select>
                            </a-form-item> -->

                        </a-col>
                    </a-row>

                    <!-- <a-divider v-if="!teamProject" dashed orientation="left"></a-divider>

                    <a-row>
                        <a-col :span="12">
                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Pembimbing"
                            >
                                <a-select
                                    v-decorator="['advisor_id']"
                                    placeholder="Pilih Pembimbing"
                                >
                                    <a-select-option
                                        v-for="d in advisors"
                                        :key="d.id"
                                        :value="d.id"
                                    >
                                        {{ d.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-if="!teamProject"
                                :label-col="{ span: layout.label }"
                                :wrapper-col="{ span: layout.wrapper }"
                                label="Mentor"
                            >
                                <a-select
                                    v-decorator="['mentor_id']"
                                    placeholder="Pilih Mentor"
                                >
                                    <a-select-option
                                        v-for="d in advisors"
                                        :key="d.id"
                                        :value="d.id"
                                    >
                                        {{ d.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row> -->

                    <a-form-item
                        :wrapper-col="{
                            span: layout.wrapper,
                            offset: layout.label
                        }"
                    >
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="processing"
                            :disabled="processing"
                            >Submit</a-button
                        >
                    </a-form-item>
                </a-form>
            </a-skeleton>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        user_hash: {
            type: String,
            default: ""
        },
        team_project: {
            type: String,
            default: "0"
        }
    },
    created() {
        this.fetchClasses()
        //this.fetchAdvisors()

        this.fetchBranches()

        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    computed: {
        editing() {
            return this.user_hash !== "";
        },
        teamProject() {
            return this.team_project === "1" 
        },
        title() {
            return !this.teamProject ? "Peserta" : "Tim Project"
        },
        activeBank() {
            return this.$laravel.bank
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            hash: null,
            item: {},
            classes: [],
            advisors: [],
            branches: [],
        };
    },
    methods: {
        fetchClasses() {
            this.$http
                .get(
                    this.routeUri("api.training-classes"))
                .then(res => (this.classes = res.data.classess))
                .finally(() => (this.preload = false));
        },
        fetchAdvisors() {
            this.$http
                .get(
                    this.routeUri("api.training-members") + "?is_attendant=0&")
                .then(res => (this.advisors = res.data.members))
                .finally(() => (this.preload = false));
        },
        fetchBranches() {
            let params = {
                bank: this.activeBank.hash
            }

            this.$http
                .get(
                    this.routeUri("api.branches") + '?' + this.$qs.stringify(params))
                .then(res => (this.branches = res.data.branches.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    if(formData["birthday"] != undefined){
                            formData.birthday =  formData["birthday"].format(
                            "YYYY-MM-DD"
                        )
                    }

                    if(formData.branch_id == null){
                        delete formData["branch_id"]
                    }

                    formData.roles = {}

                    if(!this.teamProject){
                        formData.roles.classical = 'attendant'

                        formData.roles.performance = 'attendant'
                        formData.roles.paper = 'attendant'
                        formData.roles.project = 'attendant'
                        formData.roles.evaluation = 'attendant'
                    }else{
                        // formData.roles.push({performance: formData.performance_role})
                        // formData.roles.push({paper: formData.paper_role})
                        // formData.roles.push({project: formData.project_role})
                        // formData.roles.push({evaluation: formData.evaluation_role})

                        formData.roles.classical = formData.classical_role

                        formData.roles.performance = formData.ojt_role
                        formData.roles.paper = formData.ojt_role
                        formData.roles.project = formData.ojt_role
                        formData.roles.evaluation = formData.ojt_role
                    }
                    
                    formData.generate_password = true

                    if(!this.teamProject)
                        formData.is_attendant = true
                    else
                        formData.is_attendant = false


                    if (this.editing) {
                        formData.type = this.type
                        promise = this.$http.put(
                            this.routeUri('general.account.user.update', {user_hash: this.hash}),
                            formData
                        );
                    } else {
                        promise = this.$http.post(
                            this.routeUri("api.training-members.store"),
                            formData
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.back()
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        back() {
            window.location.href = this.routeUri('admin.setting.user')
        },
    },
    watch: {
        item: function(value) {
            this.hash = value.hash;
            this.form.getFieldDecorator("name", { initialValue: value.name });
            this.form.getFieldDecorator("email", { initialValue: value.email });
            this.form.getFieldDecorator("gender", {
                initialValue: value.gender
            });
            this.form.getFieldDecorator("birthplace", { initialValue: value.birthplace });
            //this.form.getFieldDecorator("division", { initialValue: value.division });
            //this.form.getFieldDecorator("position", { initialValue: value.position });
            this.form.getFieldDecorator("office_address", { initialValue: value.office_address });
            this.form.getFieldDecorator("office_phone", { initialValue: value.office_phone });
            this.form.getFieldDecorator("home_address", { initialValue: value.home_address });
            this.form.getFieldDecorator("home_phone", { initialValue: value.home_phone });
            this.form.getFieldDecorator("education", { initialValue: value.education });
            this.form.getFieldDecorator("majors", { initialValue: value.majors });
            this.form.getFieldDecorator("university", { initialValue: value.university });
            this.form.getFieldDecorator("facebook", { initialValue: value.facebook });
            this.form.getFieldDecorator("linkedin", { initialValue: value.linkedin });
            this.form.getFieldDecorator("twitter", { initialValue: value.twitter });
            this.form.getFieldDecorator("work_experience", { initialValue: value.work_experience });
            this.form.getFieldDecorator("hobby", { initialValue: value.hobby });
            this.form.getFieldDecorator("family_status", { initialValue: value.family_status });
            this.form.getFieldDecorator("mobile_phone", {
                initialValue: value.mobile_phone
            });
            this.form.getFieldDecorator("is_active", {
                initialValue: value.is_active == true ? true : false
            });
        }
    }
}
</script>